import { render, staticRenderFns } from "./DashboardDisplayer.vue?vue&type=template&id=a7148314&scoped=true&"
import script from "./DashboardDisplayer.vue?vue&type=script&lang=js&"
export * from "./DashboardDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDisplayer.vue?vue&type=style&index=0&id=a7148314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7148314",
  null
  
)

export default component.exports